<egi-modal [show]="customer" size="xl" (close)="handleClose()">
  <div header>
    <div class="d-flex justify-content-between">
      <h2>
        Customer Details for {{ customer?.first_name }}
        {{ customer?.last_name }} ({{ customer?.cust_num }})
      </h2>
    </div>
    <div
      *ngFor="let custNum of customer.cust_num; let idx = index"
      class="d-flex"
    >
      <input
        *ngIf="!loading.includes(idx)"
        role="button"
        id="excludeCustNum{{ idx }}"
        name="excludeCustNum{{ idx }}"
        type="checkbox"
        [ngModel]="isExcluded[idx]"
        (click)="handleExcludeCustNum(idx)"
      />
      <i *ngIf="loading.includes(idx)" class="fa fa-spinner fa-spin"></i>
      <label [for]="'excludeCustNum' + idx" class="pl-1 m-0" role="button">
        Exclude Customer Number ({{ customer?.cust_num[idx] }}) from Dealer
        Matching
      </label>
    </div>
  </div>

  <div class="tab-info">
    <ul class="nav nav-tabs" id="post-report-tabs" role="tablist">
      <li class="nav-item">
        <a
          href="#all-history-tab"
          class="nav-link"
          [ngClass]="{ active: activeTab === 'all' }"
          id="all"
          role="tab"
          data-toggle="tab"
          (click)="handleTabChange('all')"
          >All History</a
        >
      </li>
      <li class="nav-item">
        <a
          href="#sales-history-tab"
          class="nav-link"
          [ngClass]="{ active: activeTab === 'sales' }"
          id="sales"
          role="tab"
          data-toggle="tab"
          (click)="handleTabChange('sales')"
          >Sales History</a
        >
      </li>
      <li class="nav-item">
        <a
          href="#svc-history-tab"
          class="nav-link"
          [ngClass]="{ active: activeTab === 'svc' }"
          id="svc"
          role="tab"
          data-toggle="tab"
          (click)="handleTabChange('svc')"
          >Service History</a
        >
      </li>
      <li class="nav-item">
        <a
          href="#vin-tab"
          class="nav-link"
          [ngClass]="{ active: activeTab === 'vin' }"
          id="vin"
          role="tab"
          data-toggle="tab"
          (click)="handleTabChange('vin')"
          >Vin History</a
        >
      </li>
      <li class="nav-item">
        <a
          href="#timeline-tab"
          class="nav-link"
          [ngClass]="{ active: activeTab === 'timeline' }"
          id="timeline-tab-select"
          role="tab"
          data-toggle="tab"
          (click)="handleTabChange('timeline')"
          >Timeline</a
        >
      </li>
    </ul>

    <div
      *ngIf="tabLoading && (activeTab !== 'timeline' || !timelineLoaded)"
      class="tab-content mt-1 overflow-auto d-flex justify-content-center align-items-center"
      style="height: 65vh; width: 100%"
    >
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>

    <div
      *ngIf="!tabLoading && activeTab !== 'timeline'"
      class="tab-content mt-1 overflow-auto relative"
      style="height: 65vh"
    >
      <div class="sticky-top">
        <div
          class="bg-gray border-bottom text-bold font-size-16 padding-10 d-flex justify-content-between"
        >
          <span>{{ amountOfRecordsTxt }} </span>
          <span *ngIf="!!marketingDate">
            Marketing Start: {{ marketingDate }}, Gross Revenue Since:
            {{ grossRevenue | currency }}
          </span>
        </div>
        <ng-select
          class="w-50"
          *ngIf="activeTab === 'vin'"
          [(ngModel)]="selectedVin"
          [items]="vins"
          (change)="handleVinChange($event)"
        >
        </ng-select>
      </div>
      <div>
        <ul class="efo-list">
          <li class="border-bottom" *ngFor="let d of dmsRecordsActive">
            <div
              *ngIf="d.type === 'sales'"
              class="padding-10"
              style="background-color: rgb(255, 244, 250)"
            >
              <span class="title">
                <span class="h5"
                  >{{ d.deal_num }}
                  <span
                    class="h5"
                    *ngIf="activeTab === 'all' || activeTab === 'vin'"
                  >
                    - Sale
                  </span>
                  <span class="pull-right">{{
                    d.deal_book_date | date : 'yyyy-MM-dd'
                  }}</span></span
                ><br />
                <span class="h7"
                  >{{ d.cust_num }} - {{ d.first_name }} {{ d.last_name }} -
                  {{ d.address1 }} {{ d.zip
                  }}<span class="pull-right">{{
                    d.total_of_payments | currency
                  }}</span></span
                ><br />
                <div class="font-size-12 font-weight-normal">
                  {{ d.year }} {{ d.make }} {{ d.model }} - odometer:
                  {{ d.mileage | number }} miles
                </div>
                <div class="font-italic font-size-10 font-weight-normal">
                  Vin: {{ d.vin }}
                </div>
              </span>
            </div>
            <div
              *ngIf="d.type === 'svc'"
              class="padding-10"
              style="background-color: rgb(245, 249, 255)"
            >
              <span class="title">
                <span class="h5"
                  >{{ d.ronumber }}
                  <span
                    class="h5"
                    *ngIf="activeTab === 'all' || activeTab === 'vin'"
                  >
                    - Service </span
                  ><span class="pull-right">{{
                    d.close_date | date : 'yyyy-MM-dd'
                  }}</span></span
                ><br />
                <span class="h7"
                  >{{ d.cust_num }} - {{ d.first_name }} {{ d.last_name }} -
                  {{ d.address1 }} {{ d.zip }}
                  <span class="pull-right">
                    {{ d.roamount | currency }}
                  </span></span
                ><br />
                <div class="font-size-12 font-weight-normal">
                  {{ d.year }} {{ d.make }} {{ d.model }} - odometer:
                  {{ d.mileage | number }}
                  miles
                </div>
                <div class="font-italic font-size-10 font-weight-normal">
                  Vin: {{ d.vin }}
                </div>
                <div class="font-italic font-size-10 font-weight-normal">
                  {{ d.ops_code }}
                </div>
                <br />
                <div *ngIf="d.ops_description">
                  <div
                    class="font-italic font-size-10 font-weight-normal"
                    *ngFor="let c of d.ops_description | split : '|'"
                  >
                    {{ c }}
                  </div>
                </div>
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div
      *ngIf="(!tabLoading && activeTab === 'timeline') || timelineLoaded"
      class="tab-content mt-1 overflow-auto relative"
      style="height: 65vh"
      [hidden]="activeTab !== 'timeline'"
    >
      <egi-timeline
        *ngIf="timelineData?.length > 0"
        [events]="timelineData"
      ></egi-timeline>
    </div>
  </div>
</egi-modal>
